export default __webpack_public_path__ + "static/media/organisation.3df06a55.svg";